let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("78oxQ")).then(() => parcelRequire('2SnNI'));